import isObject from './is-object';

/**
 * Deep merge objects instead of shallow merge.
 *
 * @source https://stackoverflow.com/questions/27936772/how-to-deep-merge-instead-of-shallow-merge
 *
 * @param {*} target
 * @param  {...any} sources
 * @returns
 */
export default function mergeDeep(target, ...sources) {
	if (!sources.length) return target;
	const source = sources.shift();
	const output = { ...target };

	if (isObject(target) && isObject(source)) {
		for (const key in source) {
			if (isObject(source[key])) {
				if (!target[key]) {
					Object.assign(output, { [key]: source[key] });
				} else {
					output[key] = mergeDeep(target[key], source[key]);
				}
			} else {
				Object.assign(output, { [key]: source[key] });
			}
		}
	}

	return mergeDeep(output, ...sources);
}
